package games.polyclub.website.frontend.store.sitemap

import kotlinx.serialization.Serializable
import react.ComponentType

@Serializable
sealed interface ISitemap {
    val rootPath: String
    val pathPart: String
    val icon: Icon?
    val title: String
    val parent: ISitemap?
    val component: ComponentType<*>?
    val tags: Array<out String>
    val shortTitle: String
    val hidden: Boolean
    val isCustomLayout: Boolean

    val pathParts: List<String> get() = buildList {
        var current = this@ISitemap
        while (true) {
            add(current.pathPart)
            current = current.parent ?: break
        }
        if (rootPath.isNotEmpty()) {
            addAll(rootPath.split("/").reversed())
        }
    }.reversed()

    val path get() = pathParts.joinToString("/", prefix = "/")

    val children: List<ISitemap>
}
